import { render } from "./SeverityLabel.vue?vue&type=template&id=77a9a20c&scoped=true"
import script from "./SeverityLabel.vue?vue&type=script&lang=js"
export * from "./SeverityLabel.vue?vue&type=script&lang=js"

import "./SeverityLabel.vue?vue&type=style&index=0&id=77a9a20c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a9a20c"]])

export default __exports__